import { OnSeachEvent } from 'modules/application/list/ListApplicationController';
import { TenantRoles } from 'modules/application/tenant/TenantService';
import { Contexts } from 'modules/core/ContextProcessorService';
import { MarketplaceFeatures } from 'modules/application/marketplace/MarketplaceFeatures';
import { NavbarFeatures } from '../NavbarFeatures';
import { ListApplicationFeatures } from 'modules/application/list/ListApplicationFeatures';
import { BOTSLIST_AIAGENT_HOME_CREATE_CLICKED, APPLICATION_OPENED } from 'modules/application/list/ListApplicationSegmentEvents';
import { selectWhichCreationRouteToRedirect } from 'modules/application/create/steps/aiAgent';
export const ChangeSubheaderTitleEvent = 'ChangeSubheaderTitle';
export class SubheaderListController {
    static $inject = ['$rootScope', 'ContextProcessorService', 'TenantService', 'AccountService2', 'BLIP_DOMAIN', '$state', '$scope', 'SegmentService', 'BuilderAiAgentService'];
    constructor($rootScope, ContextProcessorService, TenantService, AccountService2, BLIP_DOMAIN, $state, $scope, SegmentService, BuilderAiAgentService) {
        'ngInject';
        this.$rootScope = $rootScope;
        this.ContextProcessorService = ContextProcessorService;
        this.TenantService = TenantService;
        this.AccountService2 = AccountService2;
        this.BLIP_DOMAIN = BLIP_DOMAIN;
        this.$state = $state;
        this.$scope = $scope;
        this.SegmentService = SegmentService;
        this.BuilderAiAgentService = BuilderAiAgentService;
        this.canCreateChatbot = false;
        this.isPipelineEnabled = false;
        this.canCreateTemplateHeadstart = false;
        this.canAccessTemplateHeadstart = false;
        // Ensure cleanup runs even when controller $onDestroy is not called by the framework
        this.$scope.$on('$destroy', () => {
            if (typeof this.$onDestroy === 'function') {
                this.$onDestroy();
            }
        });
    }
    async $onInit() {
        await this.checkFeatures();
        await this.ContextProcessorService.waitForInitialization();
        this.canCreateChatbot = await this.userCanCreateChatbot();
        if (this.isOrganizationEnabled) {
            this.currentTenant = this.ContextProcessorService.tenant;
            this.tenantName = this.currentTenant.name;
            await this.bindTitleListeners();
        }
        this.onListApplicationStart({ canCreateChatbot: this.canCreateChatbot });
    }
    async userCanCreateChatbot() {
        if (this.ContextProcessorService.context === Contexts.Default) {
            if (this.isOrganizationEnabled || this.isCreateButtonsDisabledOnSharedView) {
                return false;
            }
            return true;
        }
        else {
            const userAccount = await this.AccountService2.me();
            const userIdentity = `${encodeURIComponent(userAccount.email)}@${this.BLIP_DOMAIN}`;
            const tenantId = this.ContextProcessorService.tenant.id;
            return await this.TenantService.hasRequiredTenantRole(userIdentity, tenantId, [TenantRoles.Admin, TenantRoles.Member]);
        }
    }
    async bindTitleListeners() {
        this.title = 'navbar.subheader.workspaceOf';
        if (this.ContextProcessorService.context === Contexts.Default &&
            this.isCreateButtonsDisabledOnSharedView) {
            this.title = 'navbar.subheader.sharedWithMe';
        }
        this.translateTitle = true;
        // Store the unregister function returned by $on
        this.changeSubheaderTitleUnregister = this.$rootScope.$on(ChangeSubheaderTitleEvent, (_, title) => {
            this.translateTitle = false;
            this.title = title;
        });
    }
    async checkFeatures() {
        this.isPipelineEnabled = await ListApplicationFeatures.isPipelineEnabled();
        this.isAiAgentEnabled = Boolean(this.ContextProcessorService.tenant.id) && await this.BuilderAiAgentService.validateContractStatus(this.ContextProcessorService.tenant.id);
        this.isOrganizationEnabled = await this.TenantService.isOrganizationEnabled();
        this.canCreateTemplateHeadstart = await MarketplaceFeatures.isCreateHeadstartTemplateEnabled();
        this.isCreateButtonsDisabledOnSharedView = await NavbarFeatures.isCreateButtonsOnSharedViewDisabled();
    }
    $onDestroy() {
        // Clean up the $rootScope listener
        if (this.changeSubheaderTitleUnregister) {
            this.changeSubheaderTitleUnregister();
        }
    }
    onSearchBots() {
        this.$rootScope.$emit(OnSeachEvent, this.searchText);
    }
    get shouldAppearActions() {
        // Should not appear when in tenant state
        return this.$state.current.name !== 'auth.application.tenant';
    }
    async onClickCreateAgent() {
        this.SegmentService.createOrganizationTrack(BOTSLIST_AIAGENT_HOME_CREATE_CLICKED);
        const pathToRedirect = await selectWhichCreationRouteToRedirect();
        this.$state.go(pathToRedirect, '_blank');
    }
    onListApplicationStart(object) {
        this.SegmentService.createTrack(APPLICATION_OPENED, object);
    }
}
SubheaderListController.$inject = ['$rootScope', 'ContextProcessorService', 'TenantService', 'AccountService2', 'BLIP_DOMAIN', '$state', '$scope', 'SegmentService', 'BuilderAiAgentService'];
